// Shared, request-deduped GETs for the boot-time calls that several
// components fire independently (/auth/me, /portfolio/owned-tickers).
// Identical calls made within TTL share one in-flight promise / result.
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TTL_MS = 1500;
const entries = new Map(); // key -> { promise, at }

function dedupedGet(path, params) {
  const key = `${path}?${JSON.stringify(params || {})}`;
  const hit = entries.get(key);
  if (hit && Date.now() - hit.at < TTL_MS) return hit.promise;
  const promise = axios.get(`${API}${path}`, { params, withCredentials: true })
    .then((r) => r.data)
    .catch((err) => { entries.delete(key); throw err; });
  entries.set(key, { promise, at: Date.now() });
  return promise;
}

export const getMe = () => dedupedGet('/auth/me');
export const getOwnedTickers = (params) => dedupedGet('/portfolio/owned-tickers', params);
export const invalidateOwnedTickers = () => {
  for (const k of entries.keys()) if (k.startsWith('/portfolio/owned-tickers')) entries.delete(k);
};
